import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { Box } from '../../Box/index.js';

var ToggleTipCard = function (_a) {
    var sx = _a.sx, children = _a.children, props = __rest(_a, ["sx", "children"]);
    var mergeStyles = useTheme().mergeStyles;
    var style = mergeStyles([
        {
            display: "grid",
            p: 5,
            boxShadow: 4,
            position: "relative",
            maxWidth: "100vw",
            backgroundColor: "black.100",
            borderRadius: 3,
        },
        sx,
    ]);
    return (jsx(Box, __assign({ sx: style, className: "toggle-tip-card" }, props, { children: children })));
};

export { ToggleTipCard };
//# sourceMappingURL=ToggleTipCard.js.map
